/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import axios from 'axios';
import { getToken, removeToken } from '@/utils/cookies';
import qs from 'qs';
import Vue from 'vue';
import store from '../store';
var service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
});
// Request interceptors
service.interceptors.request.use(function (config) {
  // Add X-Access-Token header to every request, you can add other custom headers here
  // if (getToken() && getToken() !== '') {
  //   config.headers['Authorization'] = getToken()
  // }
  // 在发送请求之前做某件事
  if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
    if (!config.headers['Content-Type']) {
      var obj = {};
      config.data.access_token_wx = getToken();
      for (var k in config.data) {
        // 过滤空属性字段
        if (config.data[k] !== '') {
          obj[k] = config.data[k];
        }
      }
      // From Data 与 Request payload 的区别
      config.data = qs.stringify(obj);
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    }
  }
  return config;
}, function (error) {
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(function (response) {
  var status = response.status;
  var data = response.data;
  if (status === 200) {
    if (!data.is_error) {
      return data;
    }
  } else {
    if (data.is_error) {
      Vue.$vux.toast.text(data.error);
    }
  }
}, function (error) {
  var code = parseInt(error.response.data.api_code);
  var errors = error.response.data.error;
  switch (code) {
    // case 40112:
    //   Vue.$vux.toast.show({
    //     text: errors,
    //     type: 'text',
    //     time: 2 * 1000,
    //     onHide() {
    //       removeToken()
    //       store.commit('SET_TOKEN', '')
    //     }
    //   })
    //   break
    case 40101:
      {
        removeToken();
        store.commit('SET_TOKEN', '');
        var url = localStorage.getItem('host_url');
        location.href = url + '#/login';
      }
      break;
    case 400000:
      {
        removeToken();
        store.commit('SET_TOKEN', '');
        var _url = localStorage.getItem('host_url');
        location.href = _url + '#/login';
      }
      break;
    default:
      Vue.$vux.toast.show({
        text: errors,
        type: 'warn',
        time: 2 * 1000
      });
      break;
  }
  return Promise.reject(error);
});
export default service;